<template>
  <div :class="['input-form-wrap-row','spacing-height',inputStyleClass]">
    <div class="input-label">
      <span style="color:red" v-if="required">*</span>
      <span>{{ label }}</span>
    </div>
    <el-select
      class="input-select"
      v-model="selectedValue"
      :placeholder="placeholder"
      @change="handleChange"
      size="mini"
      :disabled="disabled"
    >
      <el-option
        v-for="item in options"
        :key="item.value"
        :label="item.label"
        :value="item.value"
        style="display: block;"
      ></el-option>
    </el-select>
  </div>
</template>

<script>
export default {
  props: {
    label: String,
    value: [String, Number],
    options: Array,
    placeholder: String,
    disabled: Boolean,
    required: Boolean,
    inputClass: String
  },
  data() {
    return {
      selectedValue: this.value
    };
  },
  watch: {
    value(newVal) {
      this.selectedValue = newVal;
    },
    selectedValue(newVal) {
      this.$emit('input', newVal);
    }
  },
  computed: {
      inputStyleClass() {
        return this.inputClass ? `el-input-${this.inputClass}` : '';
      }
  },
  methods: {
    handleChange() {
      this.$emit('change', this.selectedValue);
    }
  }
}
</script>

<style lang="scss" scoped>
  .input-form {
    width: 186px;
    height: 40px;
    display: flex;
    align-items: center;
  }
  .el-input-factory{
    width: 18%;
    .input-label {
      width: 120px;
    }
  }
</style>



// WEBPACK FOOTER //
// SelectField.vue?314ddaa6